import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const useGroupDetailsValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    nazwa: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.validation.name.max'] }))
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    opis: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.validation.description.max'] }))
      .nullable()
      .optional(),
  });

  return { schema };
};
